var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"mx-4 mt-3"},[_c('div',{staticClass:"form-container"},[_c('div',{staticClass:"row justify-content-center"},[_c('div',{staticClass:"col-9"},[_c('h4',[_vm._v(_vm._s(_vm.$t('profile.change-teams-password.newtext')))])])])])])
}
var staticRenderFns = []

export { render, staticRenderFns }